/**
 * Wat begeleiders en deelnemers zeggen over de mechanismen in deze categorie:
 * de citaten die bij de analyse van een interview aan een mechanisme zijn
 * gehangen. Niet-gereviewde interviews tonen géén citaat, alleen dat het er is.
 *
 * @param {object} props
 * @param {Array<{interviewId: string, orgId: string, orgName: string, role: string, mechanism: string, quote: string, reviewed: boolean}>} props.interviews
 */
const CellInterviewsSection = ({ interviews }) => {
    if (interviews.length === 0) {
        return <p className="intelligence-state">Nog geen interviewcitaat op een mechanisme in deze categorie.</p>
    }
    return (
        <div className="intelligence-agenda-list">
            {interviews.map((row, i) => (
                <div key={`${row.interviewId}:${row.mechanism}:${i}`} className="intelligence-agenda-row">
                    <div className="intelligence-agenda-row__body">
                        <p className="intelligence-agenda-row__title">
                            {row.orgName || '(organisatie zonder naam)'}
                            {' '}<span className="intelligence-badge intelligence-badge--dimensie">{row.role}</span>
                            {' '}<span className="intelligence-badge">{row.mechanism}</span>
                            {!row.reviewed && <span className="intelligence-badge intelligence-badge--review">nog niet gereviewd</span>}
                        </p>
                        {row.reviewed && row.quote && <blockquote className="intelligence-quote">{row.quote}</blockquote>}
                    </div>
                </div>
            ))}
        </div>
    )
}

export default CellInterviewsSection
